export enum ModalSize {
  SMALL,
  MEDIUM,
  LARGE,
}
